import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserButton, useUser } from "@clerk/clerk-react";
import "./AccessCode.css";

const adminEmails = (process.env.REACT_APP_ADMIN_EMAIL || "")
  .split(",")
  .map((e) => e.trim().toLowerCase())
  .filter(Boolean);

const AccessCode = ({ setAuthenticated, setAuthCode }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { user } = useUser();
  const isAdmin = adminEmails.includes(user?.primaryEmailAddress?.emailAddress?.toLowerCase());

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const trimmed = code.trim().toUpperCase();
    if (!trimmed) {
      setError("Veuillez entrer un code d'accès.");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch("/api/validate-code", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: trimmed }),
      });
      const data = await response.json();
      if (data.valid) {
        setAuthenticated(true);
        setAuthCode(trimmed);
        navigate("/homepage");
      } else {
        setError("Code d'accès invalide.");
      }
    } catch {
      setError("Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="access-code-container">
      <div style={{ position: "fixed", top: 16, right: 16, zIndex: 100, display: "flex", alignItems: "center", gap: 12 }}>
        {isAdmin && (
          <button
            onClick={() => navigate("/admin")}
            style={{
              background: "#547d9d",
              color: "#fff",
              border: "none",
              borderRadius: 10,
              padding: "8px 16px",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Admin
          </button>
        )}
        <UserButton afterSignOutUrl="/sign-in" />
      </div>
      <div className="access-code-image"></div>
      <div className="access-code-white-box">
        <h1>Prêts à déguster ?</h1>
        <form className="access-form" onSubmit={handleSubmit}>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Entrer votre code d'accès"
          />
          <button type="submit" disabled={loading}>
            {loading ? "Vérification…" : "Valider"}
          </button>
        </form>
        {error && <p>{error}</p>}
      </div>
    </div>
  );
};

export default AccessCode;
